<template>


    <app-layout :title="__('Topics')">


        <div class="">


            <div class="max-w-9xl mx-auto sm:px-6 lg:px-8">


                <div
                    style="grid-template-rows:  max-content minmax(200px, max-content);"
                    class="grid grid-cols-2">


                    <div class="my-4 row-start-1 flex items-center">


                        <h1 class="text-2xl font-nexa text-dark-blue h-[30px]">

                            Topics

                        </h1>


                        <div class=""
                             style="height: 22px">


                            <font-awesome-icon
                                class="ml-8 justify-center font-bold"
                                style="width: 16px; height: 16px; margin-top: 4px;"
                                size="sm"
                                :icon="['far', 'filter']" />


                            <filter-drop-down
                                :selected="selected_language"
                                :choices="dropdown_languages"
                                @clicked_item="(choice) => { this.handle_click_dropdown('language',choice) }"/>


                        </div>


                    </div>


                    <NordenTable
                        :headers="topic_headers"
                        :rows="topics_rows" />


                </div>


            </div>


        </div>


    </app-layout>


</template>


<script>
import { defineComponent } from 'vue'
import AppLayout from '../Layouts/AppLayout.vue'
import NordenTable from "@/Components/NordenTable";
import FilterDropDown from "@/Components/FilterDropDown";

export default defineComponent({

    components: {
        FilterDropDown,
        NordenTable,
        AppLayout,
    },

    props: {
        topic_headers: {
            type: Array,
            default: () => {
                return [
                    {
                        name: 'Title',
                        value_key: 'name',
                        text_key: 'name',
                        column_width: 3,
                        class: 'leading-[50px] min-h-[50px]',
                    },
                    {
                        name: 'Subscribers',
                        text_key: 'subscribers',
                        value_key: 'subscribers',
                        column_width: 1,
                        class: '',
                    },
                    {
                        name: 'Content Clicks',
                        value_key: 'content_clicks',
                        text_key: 'content_clicks',
                        column_width: 4,
                        class: ''
                    },
                ]
            }
        },
        topics: {
            type: Array,
            default: () => {
                return [
                    {
                        id: 1,
                        name: 'Countries and Regions',
                        subscribers: 76123,
                        content_clicks: '4.1%',
                    },
                    {
                        id: 2,
                        name: 'Culture, Leisure and Media',
                        subscribers: 76123,
                        content_clicks: '4.1%',
                    },
                    {
                        id: 3,
                        name: 'Legislation and Justice',
                        subscribers: 76123,
                        content_clicks: '4.1%',
                    },
                    {
                        id: 4,
                        name: 'Environment and Climate',
                        subscribers: 76123,
                        content_clicks: '4.1%',
                    },
                    {
                        id: 5,
                        name: 'The Nordic Region and the Surrounding World',
                        subscribers: 76123,
                        content_clicks: '4.1%',
                    },
                    {
                        id: 6,
                        name: 'Education and Research',
                        subscribers: 76123,
                        content_clicks: '4.1%',
                    },
                    {
                        id: 7,
                        name: 'Welfare and Gender Equality',
                        subscribers: 76123,
                        content_clicks: '4.1%',
                    },
                    {
                        id: 8,
                        name: 'Economy, Business and Working Life',
                        subscribers: 76123,
                        content_clicks: '4.1%',
                    },
                    {
                        id: 9,
                        name: 'Nordic Council prizes',
                        subscribers: 76123,
                        content_clicks: '4.1%',
                    },
                    {
                        id: 10,
                        name: 'Nordic Council sessions',
                        subscribers: 76123,
                        content_clicks: '4.1%',
                    },
                ];
            },
        },

        selected_language: {
            type: Object,
            default: () => {
                return {
                    id: 0,
                    name: 'All Languages'
                }
            }
        },

        dropdown_languages: {
            type: Array,
            default: () => {
                return [
                    {
                        id: 1,
                        name: 'English',
                    },
                    {
                        id: 2,
                        name: 'Danish',
                    },
                    {
                        id: 3,
                        name: 'Swedish',
                    },
                    {
                        id: 4,
                        name: 'Norwegian',
                    },
                    {
                        id: 5,
                        name: 'Finnish'
                    },
                    {
                        id: 6,
                        name: 'Icelandic',
                    },
                ]
            },
        },
    },


    computed: {

        topics_rows() {

            return _.map(this.topics, (topics) => {

                return topics;

            });

        }

    },


    methods: {

        handle_click_dropdown(field, choice) {

            let
                parameters = this.route().params
            ;

            parameters[field] = choice.id

            this.$inertia.visit(
                this.route('topics', parameters)
            );

        }

    }

})
</script>


